import styled from "styled-components"
import { theme } from "../../../../styles/theme"
import { useGetAllPartAndGroup, useGetGroupDeviceList, useNotifyMobile } from "../../../../api/main"
import { MouseEventHandler, useRef, useState } from "react"
import { Svg_Alarm } from "../../../Svg"

interface Props {
  onEvent?: (e: any) => any,
}
interface ListTarget {
  part: {id: number, name: string},
  group: {id: number, name: string},
  device: {id: number, name: string},
}

export const Section_History_Targets = ({onEvent}: Props) => {
  const ref = useRef({
    defaultListTarget: {
      part: {id: 0, name: ""},
      group: {id: 0, name: ""},
      device: {id: 0, name: ""},
    } as ListTarget,

  }).current,
  [listTarget, setListTarget] = useState(ref.defaultListTarget),
  {data: partsGroups} = useGetAllPartAndGroup(),
  {data: devices} = useGetGroupDeviceList(listTarget.group.id),
  { mutateAsync: notifyMobile, isPending } = useNotifyMobile(),
  [pushDisabledSet, setPushDisabledSet] = useState(new Set<number>())

  
  const onClick: MouseEventHandler = async e => {
    try {
      const target = e.target

      if (target instanceof HTMLElement) {
        const {dataset} = target,
              {type} = dataset

        switch (type) {
          case "part": {
            const partId = Number(dataset.partId)
            const partName = dataset.partName
            if (partId > 0)
            if (partName)
            if ((partId != listTarget.part.id) || listTarget.group.id || listTarget.device.id) {
              const newListTarget = {
                ...ref.defaultListTarget,
                part: {id: partId, name: partName}
              }
              setListTarget(newListTarget)
              onEvent?.({
                event: "click",
                type: "listTarget",
                data: {target: newListTarget}
              })
            }
            return
          }
          case "group": {
            const partId = Number(dataset.partId)
            const partName = dataset.partName
            const groupId = Number(dataset.groupId)
            const groupName = dataset.groupName
            if (partId > 0)
            if (partName)
            if (groupId > 0)
            if (groupName)
            if ((groupId != listTarget.group.id) || listTarget.device.id) {
              const newListTarget = {
                ...ref.defaultListTarget,
                part: {id: partId, name: partName},
                group: {id: groupId, name: groupName},
              }
              setListTarget(newListTarget)
              onEvent?.({
                event: "click",
                type: "listTarget",
                data: {target: newListTarget}
              })
            }
            return
          }
          case "device": {
            const deviceId = Number(target.parentElement?.dataset.deviceId)
            const driveNumber = target.parentElement?.dataset.driveNumber
            if (deviceId > 0)
            if (driveNumber)
            if (deviceId != listTarget.device.id) {
              const newListTarget = {
                ...listTarget,
                device: {id: deviceId, name: driveNumber}
              }
              setListTarget(newListTarget)
              onEvent?.({
                event: "click",
                type: "listTarget",
                data: {target: newListTarget}
              })
            }
            return
          }
          case "push": {
            if (window.confirm("푸시 알람을 보내시겠습니까?")) {
              const deviceId = Number(target.parentElement?.dataset.deviceId)
              if (!deviceId) return
              const mobileId = devices?.find(d => d.deviceId == deviceId)?.mobileId
              if (!mobileId) return
              const newSet = new Set(pushDisabledSet)
              newSet.add(deviceId)
              setPushDisabledSet(newSet)
              notifyMobile({mobileId})
                .catch(e => {
                  console.error("notifyMobile > ", e)
                  alert("API 에러")
                  newSet.delete(deviceId)
                  setPushDisabledSet(newSet)
                })
            }
            return 
          }
        }
      }

    } catch (e: any) {
      console.error(`Section_History_Targets.onClick > `, e)
    }
  }

  return (
    <SSection className="DeviceList" onClick={onClick}>
      <menu className="parts">
        {partsGroups?.map(({ partId, partName, getGroupAndNumbResponses }) => {
          const isActivePart = partId == listTarget.part.id,
                isActivePartId = isActivePart && listTarget.group.id == 0 && listTarget.device.id == 0

          return (
            <li className={isActivePart ? "active" : ""} key={partId}>
              <strong
                className={isActivePartId ? "active" : ""}
                data-type="part"
                data-part-id={partId}
                data-part-name={partName}
              >
                {partName}
              </strong>
              <menu className="groups">
                {getGroupAndNumbResponses.map(({ groupId, groupName, deviceCount }) => {
                  const isActiveGroupId = groupId == listTarget.group.id

                  return (
                    <li
                      className={isActiveGroupId ? 'active' : ''}
                      key={groupId}
                      data-type="group"
                      data-part-id={partId}
                      data-part-name={partName}
                      data-group-id={groupId}
                      data-group-name={groupName}
                    >
                      - {groupName} ({deviceCount})
                    </li>
                  )
                })}
              </menu>
            </li>
          )
        })}
      </menu>

      <menu className="devices">
        {devices?.map(({ deviceId, driveNumber, macAddress, mobileId }) => {
          const isActiveDeviceId = deviceId == listTarget.device.id
          const isDisabled = !mobileId || pushDisabledSet.has(deviceId)
          return (
            <li
              key={deviceId}
              className={isActiveDeviceId ? 'active' : ''}
              data-device-id={deviceId}
              data-drive-number={driveNumber}
            >
              <div className="wrapper" data-type="device">
                <header>{driveNumber}</header>
                <footer>{macAddress}</footer>
              </div>
              <div className={`push ${isDisabled ? "disabled" : ""}`} data-type="push">
                <Svg_Alarm />
              </div>
            </li>
          )
        })}
      </menu>
    </SSection>
  )
}

const SSection = styled.section`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 400px;
  height: calc(100% - 65px);
  overflow: hidden;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, 200px);

  & > menu {
    display: grid;
    grid-auto-rows: min-content;
    gap: 10px;
    padding: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    color: ${theme.colors.white};

    & > li {
      padding: 10px;
      border-radius: 6px;

      &.active {
        background-color: ${theme.colors.black_bg2};
      }
    }
    &.parts {
      left: 0;
      background-color: ${theme.colors.green};

      & > li {
        & > strong {
          cursor: pointer;
          &.active, &:hover {
            color: ${theme.colors.yellowgreen};
          }
        }
        & > menu {
          & > li {
            cursor: pointer;
            & * {
              pointer-events: none;
            }
            &.active, &:hover {
              color: ${theme.colors.yellowgreen};
            }
          }
        }
      }
    }
    &.devices {
      left: 200px;

      & > li {
        position: relative;
        cursor: pointer;
        border: 1px solid ${theme.colors.green};
        padding: 0;
        &:hover,
        &.active {
          background-color: ${theme.colors.green};
        }
        & > .wrapper {
          position: relative;
          z-index: 2;
          padding: 5px;

          & * {
            pointer-events: none;
          }
        }
        & > .push {
          position: absolute;
          z-index: 2;
          top: 4px;
          right: 4px;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

          & * {
            pointer-events: none;
          }
          &:hover {
            background-color: yellow;
            color: black;
          }
          &.disabled {
            pointer-events: none;
            color: gray;
          }
        }
      }
    }
  }
`